import React from "react";

import PageContentLayout from "@/App/layouts/PageContent";
import PharmacySearchForm from "./SearchForm";
import PharmacySearchResultsTable from "./ResultsTable";

const ManualClaimPharmacySearch: React.FC = () => {
  return (
    <PageContentLayout title="Search for Pharmacy" pageContentWrapperClassName="search-form-and-results-wrapper">
      <PharmacySearchForm />
      <PharmacySearchResultsTable />
    </PageContentLayout>
  );
};

export default ManualClaimPharmacySearch;
